import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentsMainComponent } from './documents-main/documents-main.component';
import { DocumentRoutingModule } from './documents-routing.module';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { SharedModule } from '@app/common/shared.module';
import { SidebarModule } from 'primeng/sidebar';
import { TabViewModule } from 'primeng/tabview';
import { TablesMainComponent } from './tables-main/tables-main.component';
import { EsgdataMainComponent } from './esgdata-main/esgdata-main.component';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { DialogModule } from 'primeng/dialog';

@NgModule({
    declarations: [DocumentsMainComponent, TablesMainComponent, EsgdataMainComponent],
    imports: [
        CommonModule,
        TableModule,
        ToastModule,
        FormsModule,
        TooltipModule,
        SharedModule,
        SidebarModule,
        TabViewModule,
        ButtonModule,
        RippleModule,
        CheckboxModule,DialogModule,
        MultiSelectModule,
        DocumentRoutingModule,        
    ],
    exports: [DocumentsMainComponent, TablesMainComponent, EsgdataMainComponent],
})
export class DocumentsModule {}
